import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getBulletins(sectionToLoad :string) {
    return this.http.get("/Employee/GetBulletinsGetIndex?sectionToLoad="+ sectionToLoad).toPromise();
  }

  getLastLogonDate() {
    return this.http.get("/Home/GetLastLogonDate", { responseType: 'text' }).toPromise();
  }

  getModules() {
    return this.http.get("/Home/GetModules").toPromise();
  }

  getClockInStatus(fromFieldKiosk:boolean, currentTimeString: any) {
    return this.http.get("/Employee/GetClockInStatus?fromFieldKiosk=" + fromFieldKiosk +"&currentTimeString=" + currentTimeString + "&where=1").toPromise();
  }

  postClockAction(requestObj: any) {
    return this.http.post("/Employee/PostClockAction",
      {
        gPSLat: requestObj.gPSLat, gPSLong: requestObj.gPSLong, clockAction: requestObj.clockAction, employee: requestObj.employee, pRCo: requestObj.pRCo, jCJMKeyID: requestObj.jCJMKeyID,
        jCJPKeyID: requestObj.jCJPKeyID, signatureData: requestObj.signatureData, clockTimeString: requestObj.clockTimeString, sMWorkOrderScopeID: requestObj.sMWorkOrderScopeID,
        sMPayType: requestObj.sMPayType, sMTripID: requestObj.sMTripID, fromGroupClock: requestObj.fromGroupClock, kioskPass: requestObj.kioskPass
      }).toPromise();
  }

  changeLanguage(type: any) {
    return this.http.post("/Account/SetLanguage", { language: type }).toPromise();
  }

  getCurrentStatus() {
    return this.http.get("/Performance/GetCurrentStatus").toPromise();
  }

  getJobs(form:string) {
    return this.http.get("/Employee/GetJobs?form=" + form).toPromise();
  }

  setJob(jCJMKeyID: any, userKeyID: any) {
    return this.http.post("/DailyReports/SetJob", { lastUsedJCJMKeyID: jCJMKeyID, userKeyID: userKeyID }).toPromise();
  }

  getPhasesByJCJMKeyID(jCJMKeyID: any) {
    return this.http.get("/Employee/GetPhasesByJCJMKeyID?jCJMKeyID=" + jCJMKeyID + "&laborOnly=true").toPromise();
  }

  getTypeSign(type: string) {
    return this.http.get("/Checklist/GetTypeSign?type=" + type).toPromise();
  }

  setHotlistItem(module) {
    return this.http.post("/Home/SetHotlistItem", { moduleID: module.ModuleID, isItemAdded: module.IsHotlistItem }).toPromise();
  }

  sendAcknowledge(bulletinID: any, bulletinAttachDocumentFlagValue: any, filename: any, bulletinSignatureText: any, bulletinFileData: any, bulletinFileName: any, isFillablePDF: any) {
    return this.http.post("/Employee/sendAcknowledge", {
      bulletinID: bulletinID, bulletinAttachDocumentFlagValue: bulletinAttachDocumentFlagValue,
      filename: filename, bulletinSignatureText: bulletinSignatureText,
      bulletinFileData: bulletinFileData, bulletinFileName: bulletinFileName, isFillablePDF: isFillablePDF
    }).toPromise();
  }

  getBulletinsGetIndex(bulletinID: any, onboardID?: any) {
    var url = "/Employee/GetBulletinsGetIndex?bulletinID=" + bulletinID + "&onboardID=" + onboardID;
    return this.http.get(url).toPromise();
  }

  getDBAttachmentList(moduleID: number, bulletinID?: any, recordGuid?: any, onboardingUser?: boolean) {
    var url = "/Document/GetDBAttachmentList?moduleID=" + moduleID + "&recordID=" + bulletinID + "&recordGuid=" + recordGuid + "&onboardingUser=" + onboardingUser;
    return this.http.get(url).toPromise();
  }

  sentBulletinSign(bulletinID: any, bulletinAttachDocumentFlagValue: any, signatureStr: any, bulletinSignatureText: any, latitude: any, longitude: any, filename: any, bulletinFileData: any,
    bulletinFileName: any, isFillablePDF: any) {
    return this.http.post("/Employee/SentBulletinSign", {
      bulletinID: bulletinID, bulletinAttachDocumentFlagValue: bulletinAttachDocumentFlagValue, signatureStr: signatureStr, bulletinSignatureText: bulletinSignatureText
      , latitude: latitude, longitude: longitude, filename: filename, bulletinFileData: bulletinFileData, bulletinFileName: bulletinFileName, isFillablePDF: isFillablePDF
    }).toPromise();
  }

  getCompanyLogo(co: number, size: string) {
    return this.http.get("/Company/GetLogo?co=" + co + "&size=" + size.toUpperCase(), { responseType: 'text' }).toPromise();
  }

  getPortalName(co: number) {
    return this.http.get("/Company/GetPortalName?co=" + co, { responseType: 'text' }).toPromise();
  }

  getAPCount() {
    return this.http.get("/Employee/GetAPCount").toPromise();
  }

  getPOReviewCount() {
    return this.http.get("/Employee/GetPOReviewCount").toPromise();
  }

  getExpenseApprovalCount() {
    return this.http.get("/Employee/GetExpenseApprovalCount").toPromise();
  }

  getEmployeeInfo() {
    return this.http.get("/Employee/GetInfo").toPromise();
  }

  updateAPCount(currentCount: number) {
    return this.http.post("/APRouter/UpdateAPCount", { currentCount: currentCount }).toPromise();
  }

  updateEXCount(currentCount: number) {
    return this.http.post("/Employee/UpdateEXCount", { currentCount: currentCount }).toPromise();
  }

  getCount() {
    return this.http.get("/Employee/GetCount").toPromise();
  }

  getUserFields() {
    return this.http.get("/Employee/GetUserFields").toPromise();
  }

  getComboItemsByFieldID(fieldID: any) {
    return this.http.get("/Employee/GetComboItemsByFieldID?fieldID=" + fieldID).toPromise();
  }

  personalInfoUpdate(postData :any) {
    return this.http.post("/Employee/PersonalInfoUpdate",
      {
        formData: postData,
        attachmentsJson: "",
        fileNamesJson: "",
        recordKeyID: null
      }).toPromise();
  }

  setDocConsent(cellPhone: any, email: string, consentPaystubs: boolean, consentW2T4: boolean, consentACA1095: boolean, optOutSMS: any) {
    return this.http.post("/Employee/SetDocConsent",
      {
        cellPhone: cellPhone,
        email: email,
        consentPaystubs: consentPaystubs,
        consentW2T4: consentW2T4,
        consentACA1095: consentACA1095,
        optOutSMS: optOutSMS
      }).toPromise();
  }

  unbindViewpointID() {
    return this.http.post("/Account/UnbindViewpointID", {}).toPromise();
  }

  getUserContext() {
    return this.http.get("/Account/GetUserContext").toPromise();
  }

  getManagerGrid() {
    return this.http.get("/Performance/GetManagerGrid").toPromise();
  }

  getPdfData(ID: string, flattenPDF: boolean = false) {
    return this.http.get("/Document/GetRawAttachmentData?attachmentID=" + ID + "&keepOriginal=false&flattenPDF=" + flattenPDF).toPromise();
  }

  getPdfFile (attachmentID: string): Observable<Blob> {
    return this.http.get(`/Document/GetPdfFile?attachmentID=${attachmentID}`, { responseType: 'blob' }).pipe(
      catchError(_error => {
        return of(null);
      })
    );
  }
}
